import React from 'react';
import { Footer } from '../Nav/Footer/Footer';
import { NavBar } from '../Nav/NavBar/NavBar';
import { Leadership } from '../Leadership/Leadership';


export const LeadershipPage = () => {

    return (
        <div>
            <NavBar />
            <Leadership />
            <Footer />
        </div>

    );
}